import React, { Fragment } from 'react'
import Table from 'UI/Table'
import Filters from 'Features/Filters'
import { filteredAssetTypes } from './Data'
import AssetTypesSubTable from './AssetTypesSubTable'
import { arrayToOptions } from 'Utilities/selectOptions'

class AssetTypesTable extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      assetTypes: this.props.assetTypes,
      filters: {
        managedByCalligo: 'All',
        assetCategory: 'All'
      }
    }
  }

  changeFilters = (filters) => {
    this.setState({ filters })
  }

  render () {
    const { filters, assetTypes } = this.state
    const { assetCategoryOptions, monitoringTypeOptions } = this.props
    const { changeFilters } = this

    const columns = [
      { Header: 'Code', accessor: 'code' },
      { Header: 'Type', accessor: 'type' },
      { Header: 'Count', id: 'type_count', accessor: type => filteredAssetTypes(filters, type.asset_types).length },
    ]

    const filterOptions = {
      calligoManagement: [
        { label: 'Calligo Management', value: true },
        { label: 'Customer', value: false },
        { label: 'Shared', value: null }
      ],
      assetCategory: assetCategoryOptions,
      dataProtection: arrayToOptions(['No', 'Commvault']),
      monitoring: arrayToOptions(['No', 'Datto', 'PRTG', 'Logicmonitor']),
      antiVirus: arrayToOptions(['No', 'Yes']),
      patching: arrayToOptions(['No', 'Yes']),
      monitoringType: monitoringTypeOptions
    }


    return (
      <Fragment>
        <Filters filters={filters} onChange={changeFilters} className='mt-3'>
          <Filters.Select filterName='managedByCalligo' label='Calligo Management' options={filterOptions.calligoManagement} />
          <Filters.Select filterName='assetCategory' label='Service Category' options={assetCategoryOptions} />
        </Filters>

        <Table {...{
          data: assetTypes,
          columns,
          SubComponent: row => <AssetTypesSubTable {...{ assetTypes: filteredAssetTypes(filters, row.original.asset_types), filterOptions }} />
        }}/>
      </Fragment>
    )
  }
}

export default AssetTypesTable
